import type { AnyAction } from 'redux';

import { reducerWrapper } from '../../../main/support/utils';
import { FETCH_SOCIAL_IMAGE_ALLOWANCE } from './actions/fetchSocialImageAllowance.action';
import type { AllowanceState } from './types/ReducerTypes';

export const INIT_STATE: AllowanceState = {
  socialImageAllowance: false,
};

const Handler = (state: AllowanceState, action: AnyAction): AllowanceState => {
  switch (action.type) {
    case FETCH_SOCIAL_IMAGE_ALLOWANCE.response:
      return {
        ...state,
        socialImageAllowance: action.data?.allowed,
      };
    default:
      return state;
  }
};

const TypelessHandler = (state: any, action: any) => {
  return Handler(state, action);
};

const AllowanceReducer = reducerWrapper(INIT_STATE, TypelessHandler, {
  request: [FETCH_SOCIAL_IMAGE_ALLOWANCE],
  error: [FETCH_SOCIAL_IMAGE_ALLOWANCE],
});

export default AllowanceReducer;
